export const enum FileExtension {
  CSV = '.csv',
  STARDOG_DESIGNER = '.stardogdesigner',
  TURTLE = '.ttl',
  ZIP = '.zip',
}
